import { h } from "preact";
import { arrowBackIcon } from "../../../assets";
import PromoBannerCoupon from "../PromoBannerCoupon";
import styles from "./promoBannerPromoRow.module.css";

function PromoBannerPromoRow({ className, discountText, productHref, isAlertType, coupon, copied, onCopy, secondaryText }) {
    const discountContent = (
        <>
            <span
                className={styles.discountIcon}
                aria-hidden="true"
                style={{ "--discount-icon": `url(${arrowBackIcon})` }}
            />
            <span>{discountText}</span>
        </>
    );

    return (
        <div className={className}>
            {discountText &&
                (productHref && !isAlertType ? (
                    <a href={productHref} className={styles.discountBadge}>
                        {discountContent}
                    </a>
                ) : (
                    <span className={styles.discountBadge}>
                        {discountContent}
                    </span>
                ))}

            {coupon && (
                <PromoBannerCoupon
                    coupon={coupon}
                    copied={copied}
                    onCopy={onCopy}
                />
            )}

            {!coupon && secondaryText && (
                <p className={styles.promoTextValue}>{secondaryText}</p>
            )}
        </div>
    );
}

export default PromoBannerPromoRow;
